export default __webpack_public_path__ + "static/media/promos-icon.42ec43ae.webp";